import React from "react";
import { Button, Dialog } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { createFavPassenger } from "../CrudAndRedux/ProfileCrud";
import { actions } from "../CrudAndRedux/ProfileRedux";
import { Field, Formik } from "formik";
import { toast } from "react-toastify";
import { Input, Select } from "../../../../_metronic/_partials/controls";
import { getAllFavPassengers } from "../../Homepage/pages/widgets/components/cruds";

const AddBtn = (props) => {
  const [open, setOpen] = React.useState(false);

  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="row flex-column container rounded p-5 mx-auto my-5 text-right">
        <Button
          className="col-md-2 col-12 text-white"
          style={{
            backgroundColor: "#6dd06d",
            borderRadius: 13,
            height: "4rem",
            padding: "1.35rem",
          }}
          onClick={() => handleClickOpen()}
        >
          <h6 className="my-auto text-white">
            <b>+ افزودن مسافر</b>
          </h6>
        </Button>
      </div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        style={{ borderRadius: 20 }}
      >
        <div style={{ padding: 30 }}>
          <Formik
            enableReinitialize
            initialValues={{}}
            onSubmit={(values) => {
              createFavPassenger(authState.user.token, values)
                .then((res) => {
                  getAllFavPassengers(authState.user.token).then((res) => {
                    dispatch(actions.getAllFavPassengers(res.data.data));
                  });
                })
                .catch(() => {
                  toast.error("مشکلی در ارتباط با سرور به وجود آمد");
                });
            }}
          >
            {({ handleSubmit, setFieldValue, values }) => {
              return (
                <>
                  <div className="d-flex mb-4">
                    <h2 className="my-auto">مشخصات مسافر</h2>
                  </div>

                  <div className="row ">
                    <div className="col-12 col-md-6 my-4">
                      <Field
                        name="passengerFirstName"
                        placeholder="نام"
                        style={{
                          height: "4rem",
                          borderRadius: 7,
                          border: "1px solid #d0cccc",
                          padding: 10,
                        }}
                        onChange={(e) => {
                          setFieldValue("passengerFirstName", e.target.value);
                        }}
                        className="w-100"
                        component={Input}
                      />
                    </div>
                    <div className="col-12 col-md-6 my-4">
                      <Field
                        name="passengerLastName"
                        placeholder="نام خانوادگی"
                        style={{
                          height: "4rem",
                          borderRadius: 7,
                          border: "1px solid #d0cccc",
                          padding: 10,
                        }}
                        onChange={(e) => {
                          setFieldValue("passengerLastName", e.target.value);
                        }}
                        className="w-100"
                        component={Input}
                      />
                    </div>
                    <div className="col-12 col-md-6 my-4">
                      <Field
                        name="passengerNationalCode"
                        placeholder="کد ملی"
                        style={{
                          height: "4rem",
                          borderRadius: 7,
                          border: "1px solid #d0cccc",
                          padding: 10,
                        }}
                        onChange={(e) => {
                          setFieldValue(
                            "passengerNationalCode",
                            e.target.value
                          );
                        }}
                        className="w-100"
                        component={Input}
                      />
                    </div>
                    <div
                      className="col-12 col-md-6 my-5"
                      style={{ height: "4rem" }}
                    >
                      <Select
                        style={{
                          borderRadius: "13px",
                          border: "1px solid #d0cccc",
                          backgroundColor: "white",
                        }}
                        name="passengerGender"
                        className="w-100 h-100"
                        onChange={(e) => {
                          setFieldValue("passengerGender", e.target.value);
                        }}
                        placeholder={"جنسیت"}
                      >
                        <option>جنسیت را انتخاب کنید</option>
                        <option value={1}>آقا</option>
                        <option value={0}>خانم</option>
                        {/* <option value={2}>کودک</option> */}
                      </Select>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap mt-4 justify-content-around">
                    <div className="col-12 col-md-6 my-4 p-1">
                      <Button
                        className="w-100"
                        onClick={() => handleClose()}
                        style={{
                          border: "1px solid darkgray",
                          color: "white",
                          backgroundColor: "darkgray",
                          padding: "1.2rem",
                          height: "4rem",
                          borderRadius: 13,
                        }}
                      >
                        <h5 className="my-auto text-white">
                          <b> انصراف</b>
                        </h5>
                      </Button>
                    </div>
                    <div className="col-12 col-md-6 my-4 p-1">
                      <Button
                        className="w-100"
                        style={{
                          border: "1px solid #6dd06d",
                          color: "white",
                          backgroundColor: "#6dd06d",
                          padding: "1.2rem",
                          height: "4rem",
                          borderRadius: 13,
                        }}
                        onClick={() => {
                          handleSubmit();
                          handleClose();
                        }}
                      >
                        <h5 className="my-auto text-white">
                          <b>ثبت</b>
                        </h5>
                      </Button>
                    </div>
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </Dialog>
    </>
  );
};

export default AddBtn;
